module.exports = __webpack_public_path__ + "img/banner_ls.71cb3427.png";